"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, Table } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { useActivityTypeQueryParam } from "@/hooks/query-param/use-activity-type-query-param";
import { ActivityFeedTableSkeletonRow } from "./ActivityFeedTableSkeletonRow";
import { ACTIVITY_FEED_PAGE_SIZE } from "./constants";
import { ActivityFeedTableHeader } from "./table-header";
import { useActivityFeedTableHeaderClassNames } from "./table-header/hooks";
import { useActivityFeedTableView } from "./view";
const ITEMS = range(ACTIVITY_FEED_PAGE_SIZE).map(() => undefined);
export function ActivityFeedTableSkeleton(t0) {
  const $ = _c(12);
  const {
    overrides
  } = t0;
  const {
    size
  } = useActivityFeedTableView();
  const headerClassNames = useActivityFeedTableHeaderClassNames();
  const {
    activityTypes
  } = useActivityTypeQueryParam();
  const t1 = overrides?.Header?.className;
  let t2;
  if ($[0] !== headerClassNames || $[1] !== t1) {
    t2 = classNames(headerClassNames, t1);
    $[0] = headerClassNames;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activityTypes || $[4] !== t2) {
    t3 = <ActivityFeedTableHeader activityTypes={activityTypes} className={t2} />;
    $[3] = activityTypes;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== overrides) {
    t4 = t5 => {
      const {
        index: index_0
      } = t5;
      return <ActivityFeedTableSkeletonRow index={index_0} overrides={overrides} />;
    };
    $[6] = overrides;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== size || $[9] !== t3 || $[10] !== t4) {
    t5 = <Table dividers={true} header={t3} itemKey={_temp} items={ITEMS} renderRow={t4} size={size} />;
    $[8] = size;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(_, index) {
  return index;
}